var p2s = /,?([a-z]),?/gi;
export default function parsePathArray(path) {
    return path.join(',').replace(p2s, '$1');
}
//# sourceMappingURL=parse-path-array.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_path-util@2.0.8@@antv/path-util/esm/parse-path-array.js
// module id = null
// module chunks = 